import Relay from 'react-relay';
import { fromGlobalId } from 'graphql-relay';

const uuidRegex = /[0-9a-fA-F\-]{30,40}/;

function getPreferredSnapshotEntityId(entity?: { id?: string | null; realId?: string | null } | null): string | null {
    if (!entity) return null;
    if (entity.realId) return entity.realId;
    if (!entity.id) return null;
    if (uuidRegex.test(entity.id)) return entity.id;
    try { return fromGlobalId(entity.id).id || entity.id; } catch { return entity.id; }
}

export interface UpdateEnvironmentStateMutationProps {
    testInvocation: {
        id: string;
        realId?: string;
        version: number;
    };
    environmentState: string; // pre-serialized JSON string
    testRunId?: string | null;
}

export default class UpdateEnvironmentStateMutation extends Relay.Mutation<UpdateEnvironmentStateMutationProps, any> {
    private mutationProps: UpdateEnvironmentStateMutationProps;

    constructor(props: UpdateEnvironmentStateMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {updateTestInvocationEnvironmentState}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on UpdateTestInvocationEnvironmentStatePayload {
                testInvocation {
                    id
                    environmentState
                    version
                }
                success
                conflict
                error
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                testInvocation: this.mutationProps.testInvocation.id,
            },
        }, {
            // FIELDS_CHANGE only selects tracked entity fields; the callbacks also need the
            // acknowledgement fields, which are never tracked in the store.
            type: 'REQUIRED_CHILDREN',
            children: [Relay.QL`
                fragment on UpdateTestInvocationEnvironmentStatePayload {
                    success
                    conflict
                    error
                }
            `],
        }];
    }

    getVariables() {
        const id = getPreferredSnapshotEntityId(this.mutationProps.testInvocation) || this.mutationProps.testInvocation.id;
        return {
            testInvocationId: id,
            environmentState: this.mutationProps.environmentState,
            version: this.mutationProps.testInvocation.version,
            testRunId: this.mutationProps.testRunId || null,
        };
    }
}
